import React from 'react';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { TrashIcon as Trash } from '@heroicons/react/24/outline';
import { useDeleteNotesWarningModal } from './useDeleteNotesWarningModal';
import { useTranslation } from 'react-i18next';

export function DeleteNotesWarningModal() {
  const { isOpen, closeModal, payload } = useDeleteNotesWarningModal();
  const { t } = useTranslation(['carnet']);
  return (
    <SimpleModal
      isOpen={isOpen}
      title={t('carnet:evaluationForm.deleteNotesWarning.title')}
      buttonIcon={Trash}
      validateTitle={t(
        'carnet:evaluationForm.deleteNotesWarning.validateTitle',
      )}
      validateAction={() => {
        if (payload?.callback) {
          payload.callback();
        }
        closeModal();
      }}
      closeModalFct={() => closeModal()}
    >
      {t('carnet:evaluationForm.deleteNotesWarning.body')}
    </SimpleModal>
  );
}
